import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, SubmissionError } from "redux-form";
import { compose, withHandlers } from "recompose";
import { find } from "lodash";
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import CardTitle from "react-md/lib/Cards/CardTitle";

import Button from "react-md/lib/Buttons/Button";

import TextField from "../../form/TextField";
import SelectField from "../../form/SelectField";

import { countryCodes } from "../../../enums";

import { setActiveForm } from "../../../actions/appActions";
import {
  updateOrganizationNormal,
  getOrganizationNormal
} from "../../../actions/resourceActions";
import {DebugElement} from "../../../Atollon/debug";

const SubjectDetails = ({
  handleSubmit,
  activeForm,
  setActiveForm,
  initialValues
}) => (
  <Card className="card">
      <DebugElement text={"src/components/settings/organizationEdit/SubjectDetails.js"}/>
    <CardTitle title="DETAILY SUBJEKTU" />
    <Card raise className="card-margin">
      <CardText>
        {activeForm === "organizationSubjectDetails" ? (
          <form onSubmit={handleSubmit}>
            <div className="flex-col">
              <div className="flex-col margin-bottom">
                <Field
                  component={TextField}
                  label="Název organizace"
                  name="name"
                />
                <Field component={TextField} label="Adresa" name="address1" />
                <Field component={TextField} label="Adresa 2" name="address2" />
                <Field component={TextField} label="Město" name="city" />
                <Field component={TextField} label="PSČ" name="zipCode" />
                <Field
                  component={SelectField}
                  label="Země"
                  name="countryCode"
                  menuItems={countryCodes}
                />
              </div>
              <div className="flex-row flex-right">
                <Button
                  raised
                  className="btn"
                  label="Cancel"
                  onClick={() => setActiveForm(null)}
                />
                <Button
                  raised
                  className="btn btn-primary"
                  label="Uložit"
                  type="submit"
                />
              </div>
            </div>
          </form>
        ) : (
            <div>
          <div
            className="flex-row flex-space-between"
          >
            <div>
              <div className="flex-row">
                <p className="profile-label">Název organizace:</p>
                <p>{initialValues.name}</p>
              </div>
              <div className="flex-row">
                <p className="profile-label">Adresa:</p>
                <p>{initialValues.address1}</p>
              </div>
              <div className="flex-row">
                <p className="profile-label">Adresa 2:</p>
                <p>{initialValues.address2}</p>
              </div>
            </div>
            <div>
              <div className="flex-row">
                <p className="profile-label">Město:</p>
                <p>{initialValues.city}</p>
              </div>
              <div className="flex-row">
                <p className="profile-label">PSČ:</p>
                <p>{initialValues.zipCode}</p>
              </div>
              <div className="flex-row">
                <p className="profile-label">Země:</p>
                <p>
                  {!initialValues.countryCode ||
                  !find(
                    countryCodes,
                    c => c.value === initialValues.countryCode
                  )
                    ? ""
                    : find(
                        countryCodes,
                        c => c.value === initialValues.countryCode
                      ).label}
                </p>
              </div>
            </div>
          </div>
                <Button
                    raised
                    className="btn btn-primary"
                    label="Upravit"
                    type="submit"
                    onClick={() => setActiveForm("organizationSubjectDetails")}
                />
            </div>
        )}
      </CardText>
    </Card>
  </Card>
);

export default compose(
  connect(({ app: { form: { activeForm } } }) => ({ activeForm }), {
    setActiveForm,
    updateOrganizationNormal,
    getOrganizationNormal
  }),
  withHandlers({
    onSubmit: () => async (formData, dispatch, props) => {
      const {
        updateOrganizationNormal,
        getOrganizationNormal,
        organization,
        setActiveForm
      } = props;
      const { name, address1, address2, city, zipCode, countryCode } = formData;

      if (
        await updateOrganizationNormal({
          ...organization,
          name,
          address: {
            address1,
            address2,
            city,
            zipCode,
            countryCode: countryCode === "NO_COUNTRY" ? null : countryCode
          }
        })
      ) {
        getOrganizationNormal(organization.identifier);
        setActiveForm(null);
      } else {
        throw new SubmissionError({
          zipCode: "Úprava se nezdařila."
        });
      }
    }
  }),
  reduxForm({ form: "organizationSubjectDetails", enableReinitialize: true })
)(SubjectDetails);



// WEBPACK FOOTER //
// ./src/components/settings/organizationEdit/SubjectDetails.js